import { render, staticRenderFns } from "./rotulo.vue?vue&type=template&id=71c01292"
import script from "./rotulo.ts?vue&type=script&lang=js&external"
export * from "./rotulo.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71c01292')) {
      api.createRecord('71c01292', component.options)
    } else {
      api.reload('71c01292', component.options)
    }
    module.hot.accept("./rotulo.vue?vue&type=template&id=71c01292", function () {
      api.rerender('71c01292', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/rotulopersonalizado/rotulo.vue"
export default component.exports